'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropType = exports.render = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReactComponent = function isReactComponent(Component) {
  if (Component.prototype && Component.prototype.isReactComponent) {
    return true;
  }

  return Component.propTypes || Component.defaultProps;
};

var render = exports.render = function render(Renderer, props) {
  (0, _reactUtils.invariant)(typeof Renderer === 'function', 'RenderProp: expected Renderer to be a function, got ' + (typeof Renderer === 'undefined' ? 'undefined' : _typeof(Renderer)) + ')');

  return isReactComponent(Renderer) ? _react2.default.createElement(Renderer, props) : Renderer(props);
};

var getPropType = exports.getPropType = function getPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;

  return (0, _createChainablePropType2.default)(_component2.default, 'renderProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/utils/propTypes/renderProp.js
// module id = 109
// module chunks = 0